'use strict';

// Show modal on mobile menu button click
$('#tabMenuBtn svg').on('click', function () {
    if ($(window).width() < 992) {
        $('#mobileTabModal').addClass('show');

        // Show existing backdrop
        $('.modal-background').addClass('d-block');

        // Prevent body scroll
        $('body').addClass('modal-open');
    }
});

/**
 * Hides the mobile modal and restores the UI state.
 * Removes the 'show' class from the modal, hides the backdrop,
 * and re-enables body scroll by removing the appropriate classes.
 */
function hideMobileModal() {
    $('#mobileTabModal').removeClass('show');

    // Hide backdrop
    $('.modal-background').removeClass('d-block');

    // Restore body scroll
    $('body').removeClass('modal-open');
}

// Hide modal when clicking nav links or close icon
$('#mobileTabModal .nav-link, #mobileTabModal .close-tab-modal-icon').on('click', function () {
    if ($(window).width() < 992) {
        hideMobileModal();
    }
});

// Close modal when clicking on backdrop
$('.modal-background').on('click', function () {
    if ($(window).width() < 992) {
        hideMobileModal();
    }
});

// Close modal if resized to desktop
$(window).on('resize', function () {
    if ($(window).width() >= 992) {
        hideMobileModal();
    }
});

var $section = $('.coloured-diamonds-section');

if ($section.children().length > 1) {
    $section.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: false
                }
            }
        ]
    });
}

/**
 * Static Tabs + Accordion behavior
 * - Clicking a tab header shows its tab-pane
 * - Inside that tab, only the first accordion item is expanded
 * - All other accordion items are collapsed
 */
(function () {
    /**
     * Ensures only the first collapse inside each accordion is open
     * and others are closed, with ARIA kept in sync.
     * @param {JQuery} $pane - The tab pane element to scan for accordions
     */
    function resetAccordionInPane($pane) {
        if (!$pane || !$pane.length) return;

        var $accordions = $pane.find('.accordion');
        $accordions.each(function () {
            var $accordion = $(this);
            var $collapses = $accordion.find('.collapse');
            if (!$collapses.length) return;

            $collapses.each(function (idx) {
                var $collapse = $(this);
                var panelId = $collapse.attr('id');
                var $btn = $accordion.find('[data-target="#' + panelId + '"]');

                if (idx === 0) {
                    $collapse.addClass('show');
                    $btn.removeClass('collapsed').attr('aria-expanded', 'true');
                } else {
                    $collapse.removeClass('show');
                    $btn.addClass('collapsed').attr('aria-expanded', 'false');
                }
            });
        });
    }

    /**
     * Activates a tab within a container and resets its accordion.
     * @param {JQuery} $container - The wrapper containing headers and panes
     * @param {JQuery} $trigger - The clicked tab header button/link
     */
    function activateTab($container, $trigger) {
        var targetSel = $trigger.attr('data-target');
        if (!targetSel) return;

        var $allPanes = $container.find('.tab-pane');
        var $targetPane = $container.find(targetSel);

        // Toggle tab headers
        $container.find('.tab-headers .nav-link').each(function () {
            var $btn = $(this);
            var isActive = $btn.is($trigger);
            $btn.toggleClass('active', isActive)
                .attr('aria-selected', isActive ? 'true' : 'false');
        });

        // Toggle tab panes
        $allPanes.removeClass('active show');
        $targetPane.addClass('active show');

        // Reset accordions inside the active pane
        resetAccordionInPane($targetPane);
    }

    /**
     * Initialize behavior for each static tab container
     */
    function initStaticTabs() {
        // Support both .static-tab-container and legacy .tab-container
        var $containers = $('.static-tab-container, .tab-container');
        if (!$containers.length) return;

        $containers.each(function () {
            var $container = $(this);

            // Bind click on tab headers
            $container.on('click', '.tab-headers .nav-link', function (e) {
                // Buttons already; just prevent propagation issues
                e.preventDefault();
                activateTab($container, $(this));
            });

            // Initial state: prefer any .nav-link.active; else first
            var $initial = $container.find('.tab-headers .nav-link.active').first();
            if (!$initial.length) {
                $initial = $container.find('.tab-headers .nav-link').first();
            }

            if ($initial && $initial.length) {
                activateTab($container, $initial);
            } else {
                // If no headers found, still try to sanitize visible pane accordions
                resetAccordionInPane($container.find('.tab-pane.active, .tab-pane.show').first());
            }
        });
    }

    // Initialize on DOM ready
    $(function () {
        initStaticTabs();
    });
}());
